import RecentSearchProviderI18nKeys from "./RecentSearchProvider/RecentSearchProvider.i18n";
import RequiredIndicatorI18nKeys from "./RequiredIndicator/RequiredIndicator.i18n";
import setYupLocaleI18nKeys from "./setYupLocale/setYupLocale.i18n";
import TimeFormFieldI18nKeys from "./TimeFormField/TimeFormField.i18n";

export default {
  ...RecentSearchProviderI18nKeys,
  ...RequiredIndicatorI18nKeys,
  ...setYupLocaleI18nKeys,
  ...TimeFormFieldI18nKeys,
};
